// JavaScript Document
//components/configuration/ConfigStandard.js
import React from 'react';

//Theme
import { makeStyles } from '@material-ui/core/styles';

import {
    //Buttons & chips
    Button,
    //Layout
    Typography, Box, Paper, AppBar, Tooltip, 
    //Table
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow, 
    //Theme
    //useTheme, useMediaQuery, 
} from '@material-ui/core';
//Button Icons
import IconPrev from '@material-ui/icons/NavigateBefore';
import IconNext from '@material-ui/icons/NavigateNext';

//Date handling
import moment from 'moment';

//Custom component imports
import dsutils from './Utils';
const utils = dsutils();

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },

    calday : {
        borderRight : '1px solid rgba(224, 224, 224, 1)',
        cursor: 'pointer',
        width : `calc(100% / 7)`,
        textAlign: 'center',
        paddingLeft: 0,
        paddingRight: 0,
        '&:hover': {
            backgroundColor: theme.palette.background.default
        }
    },
    //the current day
    calThisDay : {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        borderRight : '1px solid rgba(224, 224, 224, 1)',
        cursor: 'pointer',
        width : `calc(100% / 7)`,
        textAlign: 'center',
        paddingLeft: 0,
        paddingRight: 0,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark
        }
    },
    //all days using the same daysetting
    calSameDay : {
        backgroundColor: theme.palette.primary.light,
        color : theme.palette.primary.contrastText,
        borderRight: '1px solid rgba(224, 224, 224, 1)',
        width : `calc(100% / 7)`,
        cursor : 'pointer',
        textAlign: 'center',
        paddingLeft: 0,
        paddingRight: 0,
        '&:hover': {
            backgroundColor : theme.palette.primary.main
        }
    },
    //all days that are off
    calOffDay : {
        backgroundColor: theme.palette.text.primary,
        color: theme.palette.background.default,
        borderRight : '1px solid rgba(224, 224, 224, 1)',
        cursor : 'pointer',
        width : `calc(100% / 7)`,
        textAlign: 'center',
        paddingLeft: 0,
        paddingRight: 0,
        '&:hover':{
            backgroundColor : theme.palette.text.secondary
        }
    },
    calThisOffDay : {
        backgroundColor: theme.palette.text.secondary,
        color: theme.palette.background.paper,
        borderRight : '1px solid rgba(224, 224, 224, 1)',
        cursor : 'pointer',
        width : `calc(100% / 7)`,
        textAlign: 'center',
        paddingLeft: 0,
        paddingRight: 0,
        '&:hover':{
            backgroundColor : theme.palette.text.disabled
        }
    },
    calHeader : {
        textAlign: 'center',
        overflow: 'hidden',
        lineHeight: 1,
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1)
    },
    //calendar app bar contents
    calBar : {
        display : 'flex',
        justifyContent : 'space-between',
        alignItems : 'center'
    },
}));


export default function CalendarView(props) {
	const classes = useStyles();
	//inherited variables
  	const {config, date, onChange} = props;


    //get breakpoints
    //const theme = useTheme();
	//const desktop = useMediaQuery(theme.breakpoints.up("lg"));
	//const smalltop = useMediaQuery(theme.breakpoints.up("md"));
  	//const tablet = useMediaQuery(theme.breakpoints.up("sm"));

    //Init next and prev month
    const nextMonth = moment(date).add(1, 'months').format('YYYY-MM-DD');
    const prevMonth = moment(date).subtract(1, 'months').format('YYYY-MM-DD');


    //day button label based on screen size
	const dayButtonLabel = (e) => {
        return e[0].toUpperCase();
        /*
		if(desktop){
			return e[0].toUpperCase()+e.substring(1);
		} else if(smalltop){
			return e[0].toUpperCase()+e.substring(1, 3);
		} else if(tablet){
			return e[0].toUpperCase()+e.substring(1, 2);
		} else {
			return e[0].toUpperCase();
		}
        */
	}


    //check if curdate is in master shutdown
    const isMasterShutdown = (checkDate) => {
        if(!config.master_shutdown) return false;
        if(config.master_shutdown.length === 0) return false;
        //console.log(config.master_shutdown);
        return config.master_shutdown.findIndex(ms => ms.dateOff <= checkDate && ms.dateOn > checkDate) !== -1;
    }

    

    //get daysetting id of the provided date
    const getDateSetting = (checkDate) => {
        if(isMasterShutdown(checkDate)) return false;
        let sevent = config.special_events.find(e => e.date === checkDate);
        if(sevent) return sevent.day_settings;
        return config[moment(checkDate).format('dddd').toLowerCase()];
    }

    //todays daysetting
    const curdateSetting = getDateSetting(date);

    //console.log('curdatesetting', curdateSetting);

    //create an array of calendar dates to display
    const getCalWeeks = () => {
        //get weekday of first day of the month
        var firstday = moment(date.substring(0, 8)+'01');
        var firstweekdaynum = utils.model.days.indexOf(firstday.format('dddd').toLowerCase());
        var startdate = firstday.format('YYYY-MM-DD');
        if(firstweekdaynum !== 0){
            startdate = firstday.subtract(firstweekdaynum, 'days').format('YYYY-MM-DD');
        }
        var weeks = [];
        var thisweek = [];
        for(var n = 0; n < 50; n++){
            if(n % 7 === 0) {
                if(n !== 0) weeks.push(thisweek);
                thisweek = [];
            }
            var thisdatem = moment(startdate).add(n, 'days');
            var thisdate = thisdatem.format('YYYY-MM-DD');
            var thisday = thisdatem.format('dddd').toLowerCase();
            //stop if it's the first day and the month is different
            if(n > 7 
                && thisdate.substring(5, 7) !== date.substring(5, 7) 
                && utils.model.days.indexOf(thisday) === 0) break;
            //add day to days
            thisweek.push(thisdate);
        }
        //console.log(weeks);
        return weeks;
    }

    //render the calendar week
    const renderCalWeek = (week, i) => {
        return (<TableRow key={i}>{week.map(renderCalDay)}</TableRow>);
    }

    const getDayClass = (checkDate) => {
        let dsid = getDateSetting(checkDate);
        if(!dsid) {
            if(checkDate === date) return classes.calThisOffDay;
            return classes.calOffDay;
        }
        if(checkDate === date) return classes.calThisDay;
        if(dsid === curdateSetting) return classes.calSameDay;
        return classes.calday;
    }
    const calMonthTxt = (checkDate, format) => {
        let [year//, month, day
        ] = checkDate.split('-', 1).map(v => parseInt(v));
        if(year === (new Date()).getFullYear()) return moment(checkDate).format(format);
        return [moment(checkDate).format(format), year].join(' ');
    }
    /*
    const calDayTxt = (checkDate) => {
        let [year, month, day] = checkDate.split('-').map(d => parseInt(d));
        let nowdate = new Date();
        if(year !== nowdate.getFullYear()) return [month, day, year].join('/');
        if()
    }
    */

    //render the calendar day
    const renderCalDay = (caldate, i) => {
        var daytxt = parseInt(caldate.substring(8, 10));
        var dsid = getDateSetting(caldate);
        if(caldate.substring(5, 7) !== date.substring(5, 7)) daytxt = [parseInt(caldate.substring(5, 7)), daytxt].join('/');
        return (<Tooltip arrow key={i} title={dsid ? config.daysettings[dsid].name : 'Off'}>
            <TableCell hover onClick={e => onChange(caldate)} className={getDayClass(caldate)} key={i}>{daytxt}</TableCell>
            </Tooltip>);
    }


	
  	return (
    	<div className={classes.root}>
            <AppBar position='static' color='default' >
                <Box className={classes.calBar}>
                    <Button onClick={e => onChange(prevMonth)}startIcon={<IconPrev />}>{calMonthTxt(prevMonth, 'MMM')}</Button>
                    <Typography variant='h5'>{calMonthTxt(date, 'MMMM')}</Typography>
                    <Button onClick={e => onChange(nextMonth)}endIcon={<IconNext />}>{calMonthTxt(nextMonth, 'MMM')}</Button>
                </Box>
            </AppBar>
            <TableContainer component={Paper}>
      			<Table stickyHeader aria-label="Events Calendar">
        			<TableHead>
          				<TableRow>
            				{utils.model.days.map((day, i) => (
								<TableCell key={i} className={classes.calHeader}>{dayButtonLabel(day.toUpperCase())}</TableCell>
							))}
          				</TableRow>
        			</TableHead>
        			<TableBody>
          				{getCalWeeks().map(renderCalWeek)}
        			</TableBody>
      			</Table>
    		</TableContainer>
    	</div>
  	);
}
